import { useLocale } from '../i18n'

function CartPage() {
  const { t } = useLocale()

  const handleCheckout = () => {
    if (typeof window.DC !== 'undefined' && window.DC.checkout) {
      window.DC.checkout({
        items: [
          {
            item_id: 'product_1',
            item_name: 'iPhone 15 Pro',
            category: t('products.categories.smartphone'),
            quantity: 1,
            price: 36900
          },
          {
            item_id: 'product_3',
            item_name: 'AirPods Pro',
            category: t('products.categories.headphones'),
            quantity: 1,
            price: 7490
          }
        ],
        shipping_cost: 0,
        total_price: 44390,
        order_id: 'order_12345'
      })
    }
    alert(t('cart.alert'))
  }
  
  return (
    <div className="content">
      <h2 className="page-title">{t('cart.title')}</h2>
      <p className="page-description">{t('cart.desc')}</p>
      
      <div className="demo-section">
        <h3>{t('cart.items')}</h3>
        
        <div className="cart-item">
          <p><strong>iPhone 15 Pro</strong></p>
          <p>{t('products.categories.smartphone')} - NT$ 36,900 x 1</p>
        </div>
        
        <div className="cart-item">
          <p><strong>AirPods Pro</strong></p>
          <p>{t('products.categories.headphones')} - NT$ 7,490 x 1</p>
        </div>
        
        <div className="cart-total">
          {t('cart.total', { price: 'NT$ 44,390' })}
        </div>
        
        <button className="demo-button" onClick={handleCheckout}>
          {t('cart.checkout')}
        </button>
      </div>
      
      <div className="demo-section">
        <h3>{t('cart.promos')}</h3>
        <ul>
          {t('cart.promoList').map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </div>
      
      <div className="demo-section">
        <h3>{t('cart.shipping')}</h3>
        <div className="contact-info">
          <p>{t('cart.shippingOptions.home')}</p>
          <p>{t('cart.shippingOptions.store')}</p>
          <p>{t('cart.shippingOptions.pickup')}</p>
        </div>
      </div>
    </div>
  )
}

export default CartPage
